/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component, Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';


/**
 * @class TransactionHistory
 */
class EmptySavingPage extends Component {
  /**
   *
   * @returns {*} - render
   */
  render() {
    const { history } = this.props;

    const emptySavingPage = (
      <section className="body_space">
        <div className="go_back">
          <span onClick={history.goBack}>
            <i className="fa fa-arrow-left" aria-hidden="true" />
            {' '}
            {'  '}
             Go Back
          </span>
        </div>
        <div className="empty_savings_page">
          <div className="empty_savings_page_texts">
            <h2>
            Think Big! Start with a savings plan..
            </h2>
            <p>
            To create an active saving plan click the button
              {' '}
              <br />
              {' '}
 below and choose from our various saving products
            </p>
            <Link to="/savings-plan">
              <button type="button">
              Select a savings plan
              </button>
            </Link>
          </div>
        </div>
      </section>
    );
    return <Fragment>{emptySavingPage}</Fragment>;
  }
}

EmptySavingPage.propTypes = {
  history: PropTypes.shape({}),
};

export default withRouter(EmptySavingPage);
